import { notification } from 'antd'
import apiClient from 'services/axios'
import _ from 'lodash'

/** ***********************************************
 *
 * Delete image from State, DB and Google drive
 * @param {*} id id of the image to delete
 *
 * ************************************************ */
export function deleteFile(id) {
  return apiClient.delete(`/s3/delete/${id}`).then(resp => {
    if (resp.data) {
      console.log('File deleted', resp.data)
      return resp.data.data
    }
    return null
  })
}

/** ***************************************************
 *
 * Edit the file name / Rename the file
 * @param {string} id
 * @param {string} newName
 *
 * **************************************************** */
export function updateFile(file) {
  // PUT REQUEST
  return apiClient.put(`/s3/edit/${file._id}`, { file }).then(resp => {
    if (resp.data) {
      if (resp.data.type === 'success') {
        notification.success({
          message: 'File edited with success!',
        })
      }
      return resp.data.data
    }
    notification.error({
      message: 'Error during the edition of the file',
      description: 'Please try again !',
    })
    return null
  })
}

export function searchFile(query) {
  console.log('query:', query)
}

export function loadFiles(page = 0, limit = 10, category) {
  return apiClient
    .get('/s3/files', {
      params: {
        page,
        limit,
        category,
      },
    })
    .then(resp => {
      if (resp.data) {
        // resp data contains backend response and files are in data
        return resp.data.data
      }
      return null
    })
    .catch(err => {
      notification.error({
        message: 'Error during the download of the files',
        description: 'Refresh the page to try again !',
      })
      return err
    })
}

export function loadFileById(id) {
  return apiClient.get(`/s3/file/${id}`).then(resp => {
    if (!_.isNull(resp.data) && !_.isUndefined(resp.data)) {
      return resp.data.data
    }
    return null
  })
}

/**
 * TODO NEED TO CHANGE THIS METHOD
 * @param {} name
 */
export function downloadFile(name) {
  // First we need to create a special url and ask it to the server
  return apiClient
    .get(`/s3/file/download/${name}/get-token`)
    .then(resp => {
      console.log(resp)
      if (resp.data) {
        const { presignedUrl } = resp.data.data
        // construct url with token
        const link = document.createElement('a')
        document.body.appendChild(link)
        link.href = presignedUrl
        link.setAttribute('type', 'hidden')
        link.click() // get call is make here
      }
    })
    .catch(error => {
      notification.error({ message: error.response.data.message })
    })
}

export function loadCategories() {
  let categories = []
  return apiClient
    .get('/s3/files/categories')
    .then(resp => {
      if (resp.data && resp.status === 200) {
        console.log(resp.data)
        // todo store categories
        categories = resp.data.data
      }
      return categories
    })
    .catch(error => notification.error({ message: error.response.data.message }))
}

export function syncEmail() {
  // call backend sync email method
  return apiClient
    .get(`/s3/files/sync/email`)
    .then(resp => {
      if (resp.data) {
        console.log(resp.data)
      }
    })
    .catch(error => notification.error({ message: error.response.data.message }))
}
